import { AlertTriangle, Loader2, RefreshCw } from 'lucide-react'

export function PageLoading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="card flex min-h-40 items-center justify-center gap-2.5 p-8" role="status" aria-live="polite">
      <Loader2 size={20} className="animate-spin text-brand-600 dark:text-brand-400" aria-hidden="true" />
      <span className="text-sm text-[rgb(var(--text-muted))]">{label}</span>
    </div>
  )
}

export function DataLoadError({
  title,
  message,
  onRetry,
}: {
  title: string
  message?: string
  onRetry?: () => void
}) {
  return (
    <div className="card border-red-200 bg-red-50/60 p-5 dark:border-red-900/70 dark:bg-red-950/20" role="alert">
      <div className="flex items-start gap-3">
        <AlertTriangle size={18} className="mt-0.5 shrink-0 text-red-600 dark:text-red-400" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-red-800 dark:text-red-300">{title}</p>
          {message && <p className="mt-1 break-words text-xs text-red-700/80 dark:text-red-300/80">{message}</p>}
          {onRetry && (
            <button type="button" onClick={onRetry} className="btn-secondary mt-3 h-9 px-3 text-xs">
              <RefreshCw size={14} aria-hidden="true" /> Retry
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
